import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton } from '@taiga-ui/core';
import { TuiPreview } from '@taiga-ui/kit';
import { PhotoModule } from '@src/app/modules/photo';
import { SharedModule } from '@src/app/shared';

import { ImagesGroupViewComponent } from './images-group-view.component';
import { PreviewComponent } from './components';

@NgModule({
  declarations: [ImagesGroupViewComponent, PreviewComponent],
  imports: [CommonModule, PhotoModule, ...TuiPreview, TuiButton, SharedModule],
  exports: [ImagesGroupViewComponent],
})
export class ImagesGroupViewModule {}
